import { default_sw_host } from "./constants";

export default function () {
    return default_sw_host;
}
